// 获取考试小结数据

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    _type: number; // 新老考试的区分
    element_id: number;
    student_id?: number;
    user_id?: number;
}

export interface IQuizSummary {
    quiz_time_duration: number; // 考试用时 quiz_time_duration
    total_score: number; // 总分，满分 total_score
    total_mark: number; // 总得分 total_mark
    remain_count: number; // 还剩余的考试次数
    can_redo_quiz: string; // 能否重考 can_redo_quiz
    has_subjective_question: string; // 是否有主观题, 1, 0
    subjective_mark_status: string; // 主观题评分状态,0 = 带评分； 1 = 已评分 subjective_mark_status
    subjective_score: number; // 主观题分数
    subjective_mark: number; // 主观题评分得分 subjective_mark
    objective_score: number; // 客观题分数
    objective_mark: number; // 客观题评分得分 objective_mark
    highest_mark: number; // 重考中的最高一次得分 highest_mark
    quiz_status: number;
    exam_user_name?: string;
}

export const getQuestionSummary = (data: IInput): Promise<IQuizSummary> => {
    return fetchData(Api.GET_QUIZ_SUMMARY, data).then((res: IResponse<IQuizSummary>) => {
        return res.data;
    });
};
